// Copyright (c) 2017 Deere & Company

export default Object.freeze({
    GET_NOTIFICATIONS: 'GET_NOTIFICATIONS',
    GET_OPEN_PIP_SUMMARY: 'GET_OPEN_PIP_SUMMARY',
    GET_TRANSFER_APPROVAL_COUNT: 'GET_TRANSFER_APPROVAL_COUNT',
    GET_WIP: 'GET_WIP',
    READ_HOME_PAGE_LABOR_ADDITIVE_SUMMARY: 'READ_HOME_PAGE_LABOR_ADDITIVE_SUMMARY',
    UPDATE_HOME_PAGE_LABOR_ADDITIVE_SHOW_MORE_GROUPS_VISIBILITY: 'UPDATE_HOME_PAGE_LABOR_ADDITIVE_SHOW_MORE_GROUPS_VISIBILITY',
    UPDATE_HOME_PAGE_LABOR_ADDITIVE_SUMMARY: 'UPDATE_HOME_PAGE_LABOR_ADDITIVE_SUMMARY',
    UPDATE_HOME_PAGE_LABOR_ADDITIVE_SUMMARY_MODAL_VISIBILITY: 'UPDATE_HOME_PAGE_LABOR_ADDITIVE_SUMMARY_MODAL_VISIBILITY',
    UPDATE_HOME_PAGE_SEARCH_BY: 'UPDATE_HOME_PAGE_SEARCH_BY',
    UPDATE_HOME_PAGE_SEARCH_QUERY_STRING: 'UPDATE_HOME_PAGE_SEARCH_QUERY_STRING'
});



// WEBPACK FOOTER //
// ./src/home-page/actions-list.js